module.exports = __webpack_public_path__ + "img/1103.e48f2993.jpg";